export default "__VITE_ASSET__CiqqRUkY__"